import React, {FC} from 'react'
import {mediaQuery} from '../../helpers'
import { API_URL } from '../../constants'

export const MainFooter:FC = () => {

  return  mediaQuery('(max-width: 1200px)') ? null : <div className='page-footer'>
    <div className='content'>
      <a className='footer-item' href={`${API_URL}/page/privaatsustingimused`} target='_blank'>Privaatsustingimused</a>
      <a className='footer-item' href={`${API_URL}/page/kasutustingimused`} target='_blank'>Kasutustingimused</a>
      <a className='footer-item' href='http://blog.kultuurikava.ee/abi/' target='_blank'>Abi</a>
      <a className='footer-item' href='http://blog.kultuurikava.ee/kontakt/' target='_blank'>Kontakt</a>
      <span className='footer-item'>OÜ Kultuurinet &copy; 2025</span>
    </div>
  </div>
}
